export default __webpack_public_path__ + "static/media/32.7fa87f11.jpg";